import React from 'react';
import RemoteAutoSuggest from './RemoteAutoSuggest';

const TriggerField = ({ name, label, onSelect, ...props }) => {
  const selectSuggestion = (e, suggestion) => {
    const params = {
      [`${name}Id`]: suggestion.id,
      [`${name}Type`]: suggestion.type,
    };

    onSelect(e, params);
  };

  return (
    <>
      <section>
        <label htmlFor={name}>{label}</label>
      </section>
      <section className="Trigger-field">
        <RemoteAutoSuggest
          {...props}
          name={name}
          onSuggestionSelected={selectSuggestion}
        />
      </section>
    </>
  );
};

export default TriggerField;
